import { recursiveRowNodeSearch } from "./gridUtils";

export const average = (arrayOfRows) => {
  let result = this.sum(arrayOfRows);
  Object.keys(result).forEach((key) => {
    result[key] = result[key] / arrayOfRows.length;
  });
  return result;
};

export const sum = (arrayOfRows) => {
  let result = {};
  let onFirstRow = true;
  arrayOfRows.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (onFirstRow) {
        result[key] = Number(row[key]);
      } else {
        result[key] += Number(row[key]);
      }
    });

    onFirstRow = false;
  });
  return result;
};

export const wtAvg = (params, valueField, weightField) => {
  if (!valueField || !weightField) {
    return "";
  }
  let sumValuesTimesWeights = 0;
  let sumWeights = 0;
  const allNodes = recursiveRowNodeSearch(params.rowNode);
  allNodes.forEach((node) => {
    const value = node[valueField];
    const weight = node[weightField];

    sumValuesTimesWeights += (value || 0) * (weight || 1);
    sumWeights += weight;
  });

  if (!sumWeights) {
    sumWeights = 1;
  }

  return roundToNearestHundredth(sumValuesTimesWeights / sumWeights);
};

export const wtPctAvg = (params, valueField, weightField) => {
    if (!valueField || !weightField) {
      return "";
    }
    let sumValues = 0;
    let sumWeights = 0;
    const allNodes = recursiveRowNodeSearch(params.rowNode);
    allNodes.forEach((node) => {
      let value = node?.[valueField] ?? 0;
      let weight = node?.[weightField] ?? 0;
      if (valueField.includes(" + ")) {
        const vFields = valueField.split(" + ");
        vFields.forEach(v => sumValues += node[v] || 0);
      } else {
        sumValues += (value || 0);
      }

      if (weightField.includes(" + ")) {
        const wFields = weightField.split(" + ");
        wFields.forEach(w => sumWeights += node[w] || 0);
      } else {
        sumWeights += weight;
      }
    });

    if (!sumWeights) {
      sumWeights = 1;
    }
    return roundToNearestHundredth(sumValues / sumWeights) * 100
};

export const usedPct = (params, used, alloc) => {
    if (!used || !alloc) {
      return "";
    }
    let sumUsed = 0;
    let sumAlloc = 0;
    const allNodes = recursiveRowNodeSearch(params.rowNode);
    allNodes.forEach((node) => {
      sumUsed += node?.[used] ?? 0;
      sumAlloc += node?.[alloc] ?? 0;
    });

    return roundToNearestHundredth(sumUsed / sumAlloc) * 100
}

export const weightedMean = (factorsArray, weightsArray) => {
  const sumArrayValues = (values) => {
    return values.reduce((p, c) => p + c, 0);
  };

  return sumArrayValues(
      factorsArray.map((factor, index) => factor * weightsArray[index])
    ) / sumArrayValues(weightsArray);
};

export const roundToNearestHundredth = (num) => {
  return Math.round(num * 100) / 100;
};

export const roundToNearestTenth = (num) => {
  return Math.round(num * 10) / 10;
};
